/**
 * Standardize formatted date interval
 *
 * @param {String | Date} startDate start date
 * @param {String | Date} endDate end date
 * @param {String} locale particle language
 * @returns A formatted date interval string or false is both date are invalid
 */
export const dateIntervalFormatting = (startDate, endDate, locale) => {
  const liaison = locale.includes('fr') ? 'au' : 'to'
  const defaultFormat = { year: 'numeric', month: 'long', day: 'numeric' }
  startDate = new Date(startDate)
  endDate = new Date(endDate)

  if (isNaN(startDate.getDate()) && isNaN(endDate.getDate())) {
    return false
  } else if (isNaN(startDate.getDate())) {
    return `${toLocaleUTCDateString(endDate, locale, defaultFormat)}`
  } else if (isNaN(endDate.getDate())) {
    return `${toLocaleUTCDateString(startDate, locale, defaultFormat)}`
  }
  if (startDate.getYear() !== endDate.getYear()) {
    return `${toLocaleUTCDateString(startDate, locale, defaultFormat)} ${liaison} ${toLocaleUTCDateString(endDate, locale, defaultFormat)}`
  } else if (startDate.getMonth() !== endDate.getMonth()) {
    return `${toLocaleUTCDateString(startDate, locale, { month: 'long', day: 'numeric' })} ${liaison} ${toLocaleUTCDateString(endDate, locale, defaultFormat)}`
  } else if (startDate.getDay() !== endDate.getDay()) {
    if (locale.includes('fr')) { // French format
      return `${toLocaleUTCDateString(startDate, locale, { day: 'numeric' })} ${liaison} ${toLocaleUTCDateString(endDate, locale, defaultFormat)}`
    } else { // English format
      // Note: Having only `day` and `year` is not suported by toLocaleDateString
      return `${toLocaleUTCDateString(startDate, locale, { month: 'long', day: 'numeric' })} ${liaison} ${endDate.getUTCDate()} ${endDate.getFullYear()}`
    }
  } else {
    return `${toLocaleUTCDateString(startDate, locale, defaultFormat)}`
  }
}

/**
 * Adding locale tiemzone offset resulting in the removal the timezone
 *
 * @param {Date} date A date object
 * @param locales A locale string or array of locale strings that contain one or more language or locale tags.
 * @param options An object that contains one or more properties that specify comparison options.
 * @returns toLocaleDateString without timezone
 */
export const toLocaleUTCDateString = (date, locales, options) => {
  const timeDiff = date.getTimezoneOffset() * 60000
  const adjustedDate = new Date(date.valueOf() + timeDiff)
  return adjustedDate.toLocaleDateString(locales, options)
}
